<template>
  <PrintPageLandscape
    :page-number="pageNumber"
    :page-count="pageCount"
    :background-image-url="'/img/short_teaser/short_teaser_bg.png'"
  >
    <div
      class="short-teaser-inner-page short-teaser-inner-page--location-hero"
      :data-project-number="project ? project.number : null"
    >
      <h2 v-if="customerLocationHeading" class="short-teaser-inner-page__heading">
        {{ customerLocationHeading }}
      </h2>
      <div class="short-teaser-inner-page__main">
        <figure v-if="propertyHeroImageSrc" class="short-teaser-inner-page__figure">
          <img
            class="short-teaser-inner-page__photo"
            :src="propertyHeroImageSrc"
            :alt="$t('shortTeaserPrintPage3_propertyPhotoAlt')"
          />
        </figure>
      </div>
    </div>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';

/** Matches {@link PROJECT_ATTACHMENT_TYPES.SHORT_TEASER_PROPERTY_IMAGE} on the server */
const SHORT_TEASER_PROPERTY_IMAGE_ATTACHMENT_TYPE = 'SHORT_TEASER_PROPERTY_IMAGE';

export default {
  name: 'ShortTeaserPrintPage3',

  components: {
    PrintPageLandscape,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    customerLocationHeading() {
      const project = this.project;
      if (!project) {
        return '';
      }

      let zip = '';
      let city = '';

      const useInstallationZipAndCity =
        project.installationAddressState === 'YES' && project.installationAddress;

      if (useInstallationZipAndCity) {
        zip = String(project.installationAddress.zip ?? '').trim();
        city = String(project.installationAddress.city ?? '').trim();
      } else {
        const customer = project.customer;
        if (!customer) {
          return '';
        }
        zip = String(customer.zip ?? '').trim();
        city = String(customer.city ?? '').trim();
      }

      const place = [zip, city].filter(Boolean).join(' ');
      if (!place) {
        return '';
      }
      return this.$t('shortTeaserPrintPage3_locationHeading', { place });
    },

    propertyHeroImageSrc() {
      const attachments = this.project?.attachments;
      if (!Array.isArray(attachments) || attachments.length === 0) {
        return '';
      }
      const propertyImages = attachments.filter(
        (attachment) => attachment.attachmentType === SHORT_TEASER_PROPERTY_IMAGE_ATTACHMENT_TYPE
      );
      if (propertyImages.length === 0) {
        return '';
      }
      return this.attachmentSrcPreferFullResolution(propertyImages[0]);
    },
  },

  methods: {
    sanitizeAttachmentPath(path) {
      if (!path || typeof path !== 'string') {
        return '';
      }
      if (path.indexOf('https://') !== 0) {
        return 'https://' + path;
      }
      return path;
    },

    /**
     * Use full-resolution file URL for print. Thumbnails are small previews intended for lists.
     */
    attachmentSrcPreferFullResolution(attachment) {
      if (!attachment) {
        return '';
      }
      if (attachment.path) {
        return this.sanitizeAttachmentPath(attachment.path);
      }
      if (attachment.thumbnail) {
        return this.sanitizeAttachmentPath(attachment.thumbnail);
      }
      return '';
    },
  },
};
</script>
